import {Dispatch} from 'react';

/* eslint-disable no-shadow */

export enum Config {
  'appId' = 'APP_ID',
  'appName' = 'APP_NAME',
  'versionCode' = 'VERSION_CODE',
  'versionName' = 'VERSION_NAME',
  'dev1' = 'ID1',
  'dev2' = 'ID2',
  'dev3' = 'ID3',
  'qa' = 'ID5',
  'uat' = 'ID7',
  'sandbox' = 'ID6',
  'stage' = 'ID4',
  'preprod' = 'ID8',
  'prod' = 'ID9',
  'buildType' = 'BUILD_TYPE',
  'devTool' = 'DEV_TOOL',
  'firebaseApiKey' = 'ID10',
  'firebaseVapidKey' = 'ID18',
  'firebaseAuthDomain' = 'ID11',
  'firebaseDatabaseUrl' = 'ID12',
  'firebaseProjectId' = 'ID13',
  'firebaseStorageBucket' = 'ID14',
  'firebaseMessagingSenderId' = 'ID15',
  'firebaseAppId' = 'ID16',
  'firebaseMeasurementId' = 'ID17',
  'mixpanelKey' = 'ID20',
  'mixpanelProdKey' = 'ID19',
  'deployType' = 'DEPLOY_TYPE',
  'smartlookKey' = 'ID21',
  'appcenterSecretkeyIos' = 'ID28',
  'appcenterSecretkeyAndroid' = 'ID29',
  'codepushIosKey' = 'ID30',
  'codepushIosStageTestKey' = 'ID31',
  'codepushIosDevTestKey' = 'ID32',
  'codepushAndroidKey' = 'ID33',
  'codepushAndroidStageTestKey' = 'ID34',
  'codepushAndroidDevTestKey' = 'ID35',
  'branchKey' = 'ID36',
  'branchTestKey' = 'ID37',
  'realmAppId' = 'ID38',
  'intercomId' = 'ID22',
  'intercomAndroid' = 'ID23',
  'intercomIos' = 'ID24',
  'intercomProdId' = 'ID25',
  'intercomProdAndroid' = 'ID26',
  'intercomProdIos' = 'ID27',
  'webENV' = 'WEB_ENV',
  'chatKey' = 'ID41',
  'chatTestKey' = 'ID42',
  'hiringFormDev' = 'ID43',
  'hiringFormStage' = 'ID44',
  'hiringFormQA' = 'ID45',
  'hiringFormProd' = 'ID46',
  'awsIncognitoIdentityPoolId' = 'ID48',
  'googleMapApiKeyIos' = 'ID39',
  'googleMapApiKeyAndroid' = 'ID40',
  'relicLicenseKey' = 'ID50',
  'awsLambdaMaintenanceUrl' = 'ID49',
  'chatUrl' = 'ID52',
  'chatTestUrl' = 'ID53',
  'appCipherKey' = 'ID51',
  'onfleetApiKey' = 'ID47',
  'scanditLicenseKey' = 'ID54',
  'scanditLicenseProdKey' = 'ID55',
  'onfleetApplicationKey' = 'ID56',
  'awsLocalizationUrl' = 'ID57',
  'awsLocalizationUrlRelease' = 'ID58',
  'awsLocalizationUrlWeb' = 'AWS_LOCALIZATION_URL',
  'awsLocalizationUrlReleaseWeb' = 'AWS_LOCALIZATION_URL_RELEASE',
}

export enum WebConfig {
  'deployType' = 'DEPLOY_TYPE',
  'devTool' = 'DEV_TOOL',
  'firebaseApiKey' = 'FIREBASE_API_KEY',
  'firebaseVapidKey' = 'FIREBASE_VAPID_KEY',
  'firebaseAuthDomain' = 'FIREBASE_AUTH_DOMAIN',
  'firebaseDatabaseUrl' = 'FIREBASE_DATABASE_URL',
  'firebaseProjectId' = 'FIREBASE_PROJECT_ID',
  'firebaseStorageBucket' = 'FIREBASE_STORAGE_BUCKET',
  'firebaseMessagingSenderId' = 'FIREBASE_MESSAGING_SENDER_ID',
  'firebaseAppId' = 'FIREBASE_APP_ID',
  'firebaseMeasurementId' = 'FIREBASE_MEASUREMENT_ID',
  'mixpanelKey' = 'MIXPANEL_KEY',
  'mixpanelProdKey' = 'MIXPANEL_PROD_KEY',
  'mixpanelOrderViewDevKey' = 'MIXPANEL_ORDER_VIEW_DEV_KEY',
  'mixpanelOrderViewProdKey' = 'MIXPANEL_ORDER_VIEW_PROD_KEY',
  'smartlookKey' = 'SMARTLOOK_KEY',
  'intercomId' = 'INTERCOM_ID',
  'intercomProdId' = 'INTERCOM_PROD_ID',
  'webENV' = 'WEB_ENV',
  'versionName' = 'VERSION_NAME',
  'awsLambdaMaintenanceUrl' = 'AWS_LAMBDA_MAINTENANCE_URL',
  'appCipherKey' = 'APP_CIPHER_KEY',
  'b2BMeijerURL' = 'B2B_MEIJER_URL',
  'b2BRouteEnabled' = 'B2B_ROUTE_ENABLED',
  'b2BMeijerSocketURL' = 'B2B_MEIJER_SOCKET_URL',
}

export interface EnvConfig {
  [configKey: string]: string | undefined;
}
export type LocationPermissionStatus =
  | 'unavailable'
  | 'denied'
  | 'blocked'
  | 'limited'
  | 'always'
  | 'whenInUse';

export enum BrowseNames {
  chrome = 'chrome',
  edge = 'edge',
  safari = 'safari',
  firefox = 'firefox',
  ie = 'ie',
  opera = 'opera',
  other = 'other',
}

export interface DefaultContext<T> {
  state: T;
  dispatch: null | Dispatch<any>;
}
export enum CONSTANTS {
  maxWidth = 820,
}

export enum Source {
  admin = 'admin',
  merchant = 'merchant',
  app = 'app',
  dispatcher = 'dispatcher',
  fulfillment = 'fulfillment',
}

export enum Modules {
  aboutShift = 'aboutShift',
  appStyles = 'appStyles',
  B2B = 'B2B',
  batchDetails = 'batchDetails',
  common = 'common',
  components = 'components',
  config = 'config',
  driver = 'driver',
  hiring = 'hiring',
  home = 'home',
  itemDetails = 'itemDetails',
  maintenance = 'maintenance',
  memos = 'memos',
  navigation = 'navigation',
  onBoarding = 'onBoarding',
  openShifts = 'openShifts',
  orders = 'orders',
  profile = 'profile',
  resource = 'resource',
  shopperTip = 'shopperTip',
  UPCShifts = 'UPCShifts',
  utils = 'utils',
  B2BUserOrder = 'B2BUserOrder',
}
